/**
 * i18n configuration for Spinora
 * Landing page: uses local toggle (default en). Tier pages: use profile.locale from /auth/me.
 * When SPANISH_DISABLED, always English everywhere.
 */
import i18n from 'i18next';
import { initReactI18next } from 'react-i18next';
import en from './locales/en.json';
import es from './locales/es.json';
import { SPANISH_DISABLED } from '../constants/spanishDisabled';

const resources = {
  en: { translation: en },
  es: { translation: es },
};

const storedLocale = SPANISH_DISABLED ? undefined : (typeof window !== 'undefined' ? (sessionStorage.getItem('spinora-landing-locale') as 'es') || undefined : undefined);
if (SPANISH_DISABLED && typeof window !== 'undefined') {
  sessionStorage.removeItem('spinora-landing-locale');
}
i18n.use(initReactI18next).init({
  resources,
  lng: storedLocale || 'en',
  fallbackLng: 'en',
  interpolation: { escapeValue: false },
});

if (SPANISH_DISABLED) {
  i18n.on('languageChanged', (lng) => {
    if (lng === 'es') i18n.changeLanguage('en');
  });
}

export default i18n;
